import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { ErrorsActions } from '@hglobal/common';
import { NativeStoreHelperService } from '@pt/services';

@Injectable()
export class UiEffects {
  readonly #actions = inject(Actions);
  readonly #storeHelper = inject(NativeStoreHelperService);

  handleServerError$ = createEffect(() => this.#actions.pipe(
    ofType(ErrorsActions.unexpectedServerErrorHappened),
    tap(action => this.#storeHelper.handleServerError(action.error)),
  ), { dispatch: false });
}
